
/* System defined core library */
import { Component, OnInit } from '@angular/core';

/* User defined library/components */
import { UtilityService } from '../../shared/services/utility.service';

/* User defined enums/constants */
import { ComponentType } from '../../shared/enums/scheduling.enum';

@Component({
    selector: 'app-reschedule-appointment',
    templateUrl: './reschedule-appointment.component.html',
    styleUrls: ['./reschedule-appointment.component.scss']
})

export class RescheduleAppointmentComponent {

    /* Constructor declaration with required injected services */
    constructor(private utilityService: UtilityService) {
    }

    /* Initialize the component & call require methods when component loaded first time. */
    ngOnInit() {
        sessionStorage.setItem('previousUrl', window.location.pathname);
        if (!this.utilityService.isDataValidToLoadComponent(ComponentType.RescheduleAppointmentComponent)) return;
    }

}
